<template>
    <div>
        <HeaderMenu></HeaderMenu>
     
    </div>
</template>
<script>
import axios from 'axios'
import HeaderMenu from '../HeaderMenu'
import AboutSideBar from './AboutSideBar'


export default{
    data(){
        return {
            current_locale:this.$i18n_global.locale
        }
    },
    components:{
        HeaderMenu:HeaderMenu,
        AboutSideBar:AboutSideBar
    },
    methods:{
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Pages/CoreValues.vue